import { Component } from "react"
import PropTypes from "prop-types"

import * as DiffUtils from "./diff_utils"
import ActionField from "./action_field"
import { StatusRow } from "./table_components"

class Action extends Component {
  constructor(props) {
    super(props)
    this.pathObjs = ["channel", "actions", this.props.action.id]
  }

  renderAttributes() {
    const { action, feedbackItems = {}, service } = this.props
    const serviceSlug =
      action.type === "deleted" ? this.props.originalChannel.slug : service.slug
    let fields = [
      {
        key: `action-name-${action.id}`,
        name: "Name",
        required: true,
        value: (
          <a
            target="_blank"
            href={`/services/${serviceSlug}/actions/${action.slug}`}
            rel="noreferrer"
          >
            {action.name}
          </a>
        ),
        fieldName: "name",
      },
    ]
    if (this.props.status !== "deleted") {
      fields = fields.concat([
        {
          key: `action-description-${action.id}`,
          name: "Description",
          required: true,
          value: action.description,
          fieldName: "description",
        },
        {
          key: `action-verbiage-${action.id}`,
          name: "Verbiage",
          value: action.verbiage,
          fieldName: "verbiage",
        },
        {
          key: `action-slug-${action.id}`,
          name: "Endpoint",
          required: true,
          value: action.slug,
          transform: value => `/${value}`,
          fieldName: "slug",
        },
      ])
    }
    const submenuIcons = JSON.parse(window.sessionStorage.submenuIcons)
    return fields.map(field => {
      field.diff = this.props.changes.find(
        diff =>
          diff.data &&
          diff.data.property === field.fieldName &&
          diff.path.length === 2
      )
      if (feedbackItems[field.fieldName]) {
        field.feedback = feedbackItems[field.fieldName]
        if (!submenuIcons.actionsFeedback) {
          this.props.setSessionFeedback("actions", submenuIcons)
        }
      }
      field.pathObjs = [...this.pathObjs, field.fieldName]
      return this.props.tableRow(field)
    })
  }

  prepareCollectionForRender = (items, collection) => {
    const { changes, action, diffStyle } = this.props
    if (diffStyle !== "none") {
      const itemsDeleted = DiffUtils.collectionDeletedItems(
        changes,
        this.props.originalChannel,
        ["actions", action, collection]
      )
      items = items.concat(itemsDeleted)
    }
    return DiffUtils.setupCollectionForRender(changes, items, [
      "actions",
      action,
      collection,
    ])
  }

  render() {
    const { changes, action, feedbackItems = {} } = this.props
    const actionFieldFeedback = feedbackItems.action_fields || {}

    const fieldsReordered = DiffUtils.collectionWasReordered(changes, [
      "actions",
      action,
      "action_fields",
    ])

    const actionFields = this.prepareCollectionForRender(
      action.action_fields,
      "action_fields"
    )
    return (
      <table>
        <tbody>
          {this.props.diffStyle !== "none" && (
            <StatusRow status={this.props.status} />
          )}
          {this.props.diffStyle !== "none" && fieldsReordered && (
            <tr>
              <td colSpan="3" className="reordered">
                Action fields have been reordered.
              </td>
            </tr>
          )}
          {this.renderAttributes()}
          {this.props.status !== "deleted" && (
            <tr>
              <th>Action fields</th>
              <td>
                {actionFields.length > 0
                  ? actionFields.map(f => (
                      <ActionField
                        key={`action-field-${f.id}`}
                        originalChannel={this.props.originalChannel}
                        diffStyle={this.props.diffStyle}
                        actionField={f}
                        changes={f.changes}
                        status={f.type}
                        pathObjs={[...this.pathObjs, "action_fields"]}
                        feedbackItems={actionFieldFeedback[f.id]}
                        tableRow={this.props.tableRow}
                        setSessionFeedback={this.props.setSessionFeedback}
                      />
                    ))
                  : "None"}
              </td>
              <td className="no-feedback" />
            </tr>
          )}
        </tbody>
      </table>
    )
  }
}

Action.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  diffStyle: PropTypes.string.isRequired,
  service: PropTypes.object.isRequired,
  originalChannel: PropTypes.object,
  status: PropTypes.oneOf(["new", "deleted", "updated", "stale"]).isRequired,
  action: PropTypes.object.isRequired,
  changes: PropTypes.array.isRequired,
  feedbackItems: PropTypes.object,
  tableRow: PropTypes.func.isRequired, // Should be imported
  setSessionFeedback: PropTypes.func.isRequired,
}

export default Action
